import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ZoneOfInterestDto } from '../bo/zoneOfInterest';

@Injectable({ providedIn: 'root' })
export class ZoneOfInterestService {
  constructor(private readonly http: HttpService) {}

  getAll(siteId: number): Observable<ZoneOfInterestDto[]> {
    return this.http.get<ZoneOfInterestDto[]>(`sites/${siteId}/ZoneOfInterest`);
  }

  create(siteId: number, dto: ZoneOfInterestDto): Observable<ZoneOfInterestDto> {
    return this.http.post<ZoneOfInterestDto, ZoneOfInterestDto>(`sites/${siteId}/ZoneOfInterest`, dto);
  }

  update(siteId: number, dto: ZoneOfInterestDto): Observable<ZoneOfInterestDto> {
    return this.http.put<ZoneOfInterestDto, ZoneOfInterestDto>(`sites/${siteId}/ZoneOfInterest/${dto.id}`, dto);
  }

  delete(siteId: number, id: number): Observable<void> {
    return this.http.delete<void>(`sites/${siteId}/ZoneOfInterest/${id}`);
  }
}
